'use client'

import { Suspense, type ComponentProps } from 'react'

import { usePathname } from 'next/navigation'

import { documentPath } from '@/lib/seo/document-path'
import { linkRel, requiresDocumentUrl } from '@/lib/seo/indexing-policy'

import { useIndexingPolicy } from './indexing-provider'

type Props = ComponentProps<'a'>

const ResolvedAnchor = ({ href, rel, documentUrl, ...props }: Props & { documentUrl?: string }) => {
  const policy = useIndexingPolicy()
  return <a {...props} href={href} rel={linkRel(href, rel, policy, documentUrl, props.target)} />
}

const RelativeAnchor = (props: Props) => <ResolvedAnchor {...props} documentUrl={documentPath(usePathname())} />

export const Anchor = (props: Props) => {
  if (requiresDocumentUrl(props.href)) {
    return (
      <Suspense fallback={<ResolvedAnchor {...props} />}>
        <RelativeAnchor {...props} />
      </Suspense>
    )
  }
  return <ResolvedAnchor {...props} />
}
